import React from 'react';

const PaginatorActionContext = React.createContext();

export default PaginatorActionContext;
